module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("invoice.invoiceTitle")))]), _vm._v(" "), _c('div', {
    staticClass: "mline"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "h_center"
  }, [_c('span', {
    staticClass: "pay-type-item-icon",
    on: {
      "click": function($event) {
        _vm.selectV('0')
      }
    }
  }, [_c('i', {
    class: {
      active: _vm.invoiceType == 0 ? true : false
    }
  })]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t("invoice.invoiceType0")))]), _vm._v(" "), _c('span', {
    staticClass: "pay-type-item-icon",
    staticStyle: {
      "margin-left": "120px"
    },
    on: {
      "click": function($event) {
        _vm.selectV('1')
      }
    }
  }, [_c('i', {
    class: {
      active: _vm.invoiceType == 1 ? true : false
    }
  })]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t("invoice.invoiceType1")))]), _vm._v(" "), _c('span', {
    staticClass: "pay-type-item-icon",
    staticStyle: {
      "margin-left": "120px"
    },
    on: {
      "click": function($event) {
        _vm.selectV('2')
      }
    }
  }, [_c('i', {
    class: {
      active: _vm.invoiceType == 2 ? true : false
    }
  })]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t("invoice.invoiceType2")))])]), _vm._v(" "), _c('div', {
    staticClass: "h_main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceType != '0'),
      expression: "invoiceType!='0'"
    }],
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    staticStyle: {
      "width": "200px",
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invName")))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "55px"
    }
  }, [_vm._v(_vm._s(_vm.regConfig.cfgInvTitle))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceType == '1'),
      expression: "invoiceType=='1'"
    }],
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    class: {
      ch_mg_inv: _vm.locale == 'ch', en_mg_inv: _vm.locale == 'en'
    },
    staticStyle: {
      "margin-left": "30px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invRegTitle")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regInvTitle),
      expression: "regInvTitle"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": _vm.$t("invoice.invRegTitle")
    },
    domProps: {
      "value": (_vm.regInvTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.regInvTitle = $event.target.value
      }
    }
  }), _vm._v(" "), ((_vm.regInvTitle == '' || _vm.regInvTitle == null) && _vm.dirty1 && _vm.invoiceType == '1') ? _c('span', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t("invoice.input")) + _vm._s(_vm.$t("invoice.invRegTitle")))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceType == '2'),
      expression: "invoiceType=='2'"
    }],
    staticClass: "h_main"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("invoice.VAT")))]), _vm._v(" "), _c('div', {
    staticClass: "mline"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-item",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    class: {
      L7: _vm.locale == 'ch', ch_mg_vat: _vm.locale == 'ch', en_mg_vat: _vm.locale == 'en'
    },
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddOrg")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueadd_invoice.regInvOrg),
      expression: "valueadd_invoice.regInvOrg"
    }],
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": _vm.$t("invoice.invAddOrg")
    },
    domProps: {
      "value": (_vm.valueadd_invoice.regInvOrg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.valueadd_invoice, "regInvOrg", $event.target.value)
      }
    }
  }), _vm._v(" "), ((_vm.valueadd_invoice.regInvOrg == null || _vm.valueadd_invoice.regInvOrg == '') && _vm.dirty2 && _vm.invoiceType == '2') ? _c('div', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t("invoice.input")) + _vm._s(_vm.$t("invoice.invAddOrg")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-item",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    class: {
      L7: _vm.locale == 'ch', ch_mg_vat: _vm.locale == 'ch', en_mg_vat: _vm.locale == 'en'
    },
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddTax")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueadd_invoice.regInvTax),
      expression: "valueadd_invoice.regInvTax"
    }],
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": _vm.$t("invoice.invAddTax")
    },
    domProps: {
      "value": (_vm.valueadd_invoice.regInvTax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.valueadd_invoice, "regInvTax", $event.target.value)
      }
    }
  }), _vm._v(" "), ((_vm.valueadd_invoice.regInvTax == null || _vm.valueadd_invoice.regInvTax == '') && _vm.dirty2 && _vm.invoiceType == '2') ? _c('div', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t("invoice.input")) + _vm._s(_vm.$t("invoice.invAddTax")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-item",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    class: {
      L7: _vm.locale == 'ch', ch_mg_vat: _vm.locale == 'ch', en_mg_vat: _vm.locale == 'en'
    },
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddAddr")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueadd_invoice.regInvAddr),
      expression: "valueadd_invoice.regInvAddr"
    }],
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": _vm.$t("invoice.invAddAddr")
    },
    domProps: {
      "value": (_vm.valueadd_invoice.regInvAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.valueadd_invoice, "regInvAddr", $event.target.value)
      }
    }
  }), _vm._v(" "), ((_vm.valueadd_invoice.regInvAddr == null || _vm.valueadd_invoice.regInvAddr == '') && _vm.dirty2 && _vm.invoiceType == '2') ? _c('div', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t("invoice.input")) + _vm._s(_vm.$t("invoice.invAddAddr")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-item",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    class: {
      L7: _vm.locale == 'ch', ch_mg_vat: _vm.locale == 'ch', en_mg_vat: _vm.locale == 'en'
    },
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddTel")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueadd_invoice.regInvTel),
      expression: "valueadd_invoice.regInvTel"
    }],
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": _vm.$t("invoice.invAddTel")
    },
    domProps: {
      "value": (_vm.valueadd_invoice.regInvTel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.valueadd_invoice, "regInvTel", $event.target.value)
      }
    }
  }), _vm._v(" "), ((_vm.valueadd_invoice.regInvTel == null || _vm.valueadd_invoice.regInvTel == '') && _vm.dirty2 && _vm.invoiceType == '2') ? _c('div', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t("invoice.input")) + _vm._s(_vm.$t("invoice.invAddTel")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-item",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    class: {
      L7: _vm.locale == 'ch', ch_mg_vat: _vm.locale == 'ch', en_mg_vat: _vm.locale == 'en'
    },
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddBank")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueadd_invoice.regInvBank),
      expression: "valueadd_invoice.regInvBank"
    }],
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": _vm.$t("invoice.invAddBank")
    },
    domProps: {
      "value": (_vm.valueadd_invoice.regInvBank)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.valueadd_invoice, "regInvBank", $event.target.value)
      }
    }
  }), _vm._v(" "), ((_vm.valueadd_invoice.regInvBank == null || _vm.valueadd_invoice.regInvBank == '') && _vm.dirty2 && _vm.invoiceType == '2') ? _c('div', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t("invoice.input")) + _vm._s(_vm.$t("invoice.invAddBank")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-item",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    class: {
      L7: _vm.locale == 'ch', ch_mg_vat: _vm.locale == 'ch', en_mg_vat: _vm.locale == 'en'
    },
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddAcount")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueadd_invoice.regInvAccount),
      expression: "valueadd_invoice.regInvAccount"
    }],
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": _vm.$t("invoice.invAddAcount")
    },
    domProps: {
      "value": (_vm.valueadd_invoice.regInvAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.valueadd_invoice, "regInvAccount", $event.target.value)
      }
    }
  }), _vm._v(" "), ((_vm.valueadd_invoice.regInvAccount == null || _vm.valueadd_invoice.regInvAccount == '') && _vm.dirty2 && _vm.invoiceType == '2') ? _c('div', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t("invoice.input")) + _vm._s(_vm.$t("invoice.invAddAcount")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-item",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('label', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.taxpayer")))])]), _vm._v(" "), (_vm.regConfig.cfgInvUploadFl == '1') ? _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "file-box",
    staticStyle: {
      "text-align": "center",
      "display": "inline-block"
    }
  }, [_c('div', {
    staticClass: "preview",
    style: (_vm.bdPreview)
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        _vm.changeFile()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "text-align": "center",
      "margin-left": "30px",
      "padding-top": "5px",
      "color": "red",
      "font-size": "14px"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewSrc != ''),
      expression: "previewSrc!=''"
    }]
  }, [_vm._v(_vm._s(_vm.$t("invoice.uploadReImg")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewSrc == ''),
      expression: "previewSrc==''"
    }]
  }, [_vm._v(_vm._s(_vm.$t("invoice.uploadImg")))])]), _vm._v(" "), ((_vm.bdPreview == null || _vm.bdPreview == '') && _vm.dirty2 && _vm.invoiceType == '2') ? _c('div', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t("invoice.uptaxpayer")))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceType != '0' && _vm.regConfig.cfgInvAddressFl == '1'),
      expression: "invoiceType!='0' && regConfig.cfgInvAddressFl=='1'"
    }]
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("invoice.invGetTitle")))]), _vm._v(" "), _c('div', {
    staticClass: "mline"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    class: {
      ch_mg_inv: _vm.locale == 'ch', en_mg_inv: _vm.locale == 'en'
    },
    staticStyle: {
      "margin-left": "30px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invGetName")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice_contact.contactName),
      expression: "invoice_contact.contactName"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": _vm.$t("invoice.invGetName")
    },
    domProps: {
      "value": (_vm.invoice_contact.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoice_contact, "contactName", $event.target.value)
      }
    }
  }), _vm._v(" "), ((_vm.invoice_contact.contactName == null || _vm.invoice_contact.contactName == '') && _vm.dirty3) ? _c('span', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t("invoice.input")) + _vm._s(_vm.$t("invoice.invGetName")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    class: {
      ch_mg_inv: _vm.locale == 'ch', en_mg_inv: _vm.locale == 'en'
    },
    staticStyle: {
      "margin-left": "30px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invGetPhone")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice_contact.contactPhone),
      expression: "invoice_contact.contactPhone"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": _vm.$t("invoice.invGetPhone"),
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.invoice_contact.contactPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoice_contact, "contactPhone", $event.target.value)
      }
    }
  }), _vm._v(" "), ((_vm.invoice_contact.contactPhone == null || _vm.invoice_contact.contactPhone == '') && _vm.dirty3) ? _c('span', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t("invoice.input")) + _vm._s(_vm.$t("invoice.invGetPhone")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    class: {
      ch_mg_inv: _vm.locale == 'ch', en_mg_inv: _vm.locale == 'en'
    },
    staticStyle: {
      "margin-left": "30px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invGetAddr")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice_contact.contactAddr),
      expression: "invoice_contact.contactAddr"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": _vm.$t("invoice.invGetAddr")
    },
    domProps: {
      "value": (_vm.invoice_contact.contactAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoice_contact, "contactAddr", $event.target.value)
      }
    }
  }), _vm._v(" "), ((_vm.invoice_contact.contactAddr == null || _vm.invoice_contact.contactAddr == '') && _vm.dirty3) ? _c('span', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.$t("invoice.input")) + _vm._s(_vm.$t("invoice.invGetAddr")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#00AAEE",
      "font-size": "14px",
      "margin-top": "30px",
      "margin-left": "30px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.regConfig.cfgInvoiceDesc)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("invoice.conTitle")))]), _vm._v(" "), _c('div', {
    staticClass: "mline"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    class: {
      ch_mg_contact: _vm.locale == 'ch', en_mg_contact: _vm.locale == 'en'
    },
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.conPerson")))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.cPerson))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    staticStyle: {
      "width": "200px",
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.conPhone")))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.cPhone))])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opFlag != '1'),
      expression: "opFlag!='1'"
    }],
    staticClass: "btn",
    on: {
      "click": _vm.goPre
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.pre")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: [_vm.canNext ? 'err-bounce' : ''],
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.next")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-296120ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/invoice.vue
// module id = 782
// module chunks = 10